import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataDocument_Contact } from '../../data/DataDocument_Contact';
import { DataSignatureElectronique } from '../../data/DataSignatureElectronique';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheSignatureDocument.css';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    documentASigner
    onFermeFicheSignatureDocument => méthode
****************************************************************/

var objetState = {
    idOperation: 0,
    idReservation: 0,
    documentASigner: null,

    contacts: [],
    contact: {},

    affichagePanelSignatureDocument: false,
    onAfficheDialogSignatureEffectuee: false,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheSignatureDocument extends Component {
    _selection;

    _creationContent() {

        const { contact } = this.state;
        const { tel1, email, codeOTP, signe } = contact;

        const activateBloc = this._selection.getSelectedCount() > 0
            && signe === null;

        return <Panel
            isOpen={this.props.affichagePanelSignatureDocument}
            type={PanelType.extraLarge}
            onDismiss={() => this._onAnnulation()}
            headerText='Signature de document'
            closeButtonAriaLabel="Fermer"
            onRenderFooterContent={this._onRenderFooterContent}
            onOpen={() => this._onOpen()}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row classActivate">
                    <div className="ms-Grid-col ms-sm12 ms-xl6 blocDetailList">
                        <DetailsList
                            className=""
                            items={this.state.contacts}
                            columns={this.columns}
                            selection={this._selection}
                            selectionPreservedOnEmptyClick
                        />
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-xl6 blocGestionOTP">
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <div className="ms-Grid-col ms-sm12 blocSaisieInformations">
                                <div className="ms-Grid-col ms-sm12">
                                    <EUITextField
                                        disabled={!activateBloc}
                                        label="N° de téléphone"
                                        maxLength={MaxLengths.contact.tel1}
                                        onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "contact", "tel1", newValue)}
                                        value={tel1}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12">
                                    <EUITextField
                                        disabled={!activateBloc}
                                        label="Email"
                                        maxLength={MaxLengths.contact.email}
                                        onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "contact", "email", newValue)}
                                        value={email}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 mt-2">
                                    <PrimaryButton
                                        onClick={() => this._onEnvoiCodeOTP()}
                                        className=""
                                        disabled={!(activateBloc && (tel1 || email))}>Envoyer le code</PrimaryButton>
                                </div>
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm12 ms-xl6">
                            <div className="ms-Grid-col ms-sm12 blocEnvoiDocOTP">
                                <div className="ms-Grid-col ms-sm12">
                                    <EUITextField
                                        disabled={!activateBloc}
                                        label="Code"
                                        onChange={(event, newValue) => Scriba.state().setObjetPropriete(this, "contact", "codeOTP", newValue)}
                                        value={codeOTP}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-sm12 mt-2">
                                    <PrimaryButton
                                        onClick={() => this._onSigner()}
                                        disabled={!(activateBloc && codeOTP)}>Signer</PrimaryButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Dialog
                    hidden={!this.state.onAfficheDialogSignatureEffectuee}
                    onDismiss={this._onCacheDialogSignatureEffectuee}
                    dialogContentProps={{
                        type: DialogType.largeHeader,
                        title: 'Signature effectuée',
                        subText: 'Le document vient d\'être signé'
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } }
                    }}
                >
                    <DialogFooter>
                        <DefaultButton onClick={this._onCacheDialogSignatureEffectuee} text="OK" />
                    </DialogFooter>
                </Dialog>

            </div>
        </Panel>;
    }

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({
                    contact: (this._selection.getSelectedCount() > 0 ? this._selection.getSelection()[0] : {})
                });
            }
        });

        this.state = objetState;

        this.columns = [
            {
                key: 'nom',
                name: 'Nom',
                fieldName: 'nom',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                onRender: (item) => {
                    let nom = item.nom;

                    return <span title={nom}>{nom}</span>;
                }
            },
            {
                key: 'prenom',
                name: 'Prénom',
                fieldName: 'prenom',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                headerClassName: 'ms-hiddenMdDown',
                className: 'ms-hiddenMdDown',
                onRender: (item) => {
                    let prenom = item.prenom;

                    return <span title={prenom}>{prenom}</span>;
                }

            },
            {
                key: 'tel',
                name: 'Tel',
                fieldName: 'tel',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                headerClassName: 'ms-hiddenLgDown',
                className: 'ms-hiddenLgDown',
                onRender: (item) => {
                    let tel1 = item.tel1;

                    return <span title={tel1}>{tel1}</span>;
                }

            },
            {
                key: 'email',
                name: 'Email',
                fieldName: 'email',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
                headerClassName: 'ms-hiddenXlDown',
                className: 'ms-hiddenXlDown',
                onRender: (item) => {
                    let email = item.email;

                    return <span title={email}>{email}</span>;
                }

            },
            {
                key: 'Sign',
                name: 'Signé',
                fieldName: 'Sign',
                minWidth: 30,
                maxWidth: 30,
                isResizable: true,
                onRender: (item) => {
                    let signe = item.signe;

                    if (signe !== null) {
                        return <IconButton
                            iconProps={{ iconName: 'InsertSignatureLine' }}
                            title="Signé"
                        />;
                    }
                    else {
                        return null;
                    }
                }
            }
            //InsertSignatureLine
        ];
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheSignatureDocument();
        this.props.onChargementEtatReservation();
    }

    _chargementDonnees() {
        //let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);
        //let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);
        //let rowGUIDRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.rowGUID, [this.state.rowGUID]);

        //let idReservation = this.props.idReservation;
        //let idOperation = this.props.idOperation;
        //let rowGUID = this.props.documentASigner.rowGUID;

        //if (idReservation > 0 && idOperation > 0 && rowGUID !== undefined) {
        //if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent && rowGUIDRenseigneeEtDifferent) {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des documents"
        });

        let chargementSignatureDocumentReservation = DataSignatureElectronique._chargementSignatureDocumentReservation(this.props.idReservation, this.props.idOperation, this.props.documentASigner.rowGUID);

        chargementSignatureDocumentReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = {};
                    stateTemp.idReservation = this.props.idReservation;
                    stateTemp.idOperation = this.props.idOperation;
                    stateTemp.documentASigner = this.props.documentASigner;
                    stateTemp.contacts = objetData;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
        //}
        //else {
        //    this.setState({
        //        idReservation: 0,
        //        idOperation: 0,
        //        documentASigner: null,
        //        contacts: [],
        //        contact: {}
        //    });
        //}
    }

    _onSigner = () => {
        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Signature en cours" });

        let chargementTMA = DataDocument_Contact._onSignatureDocument(this.props.idReservation, this.props.idOperation, this.state.contact.idContact, this.props.documentASigner.rowGUID, this.state.contact.codeOTP);

        chargementTMA
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this.setState({
                        enCoursDeTraitement: false,
                        messageEnCoursTraitement: '',
                        onAfficheDialogSignatureEffectuee: true
                    });

                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onEnvoiCodeOTP = () => {

        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Génération du code OTP en cours" });

        let chargementEDOCGenOTP = DataSignatureElectronique._chargementEDOCGenOTP(this.props.idReservation, this.props.idOperation, this.props.documentASigner.rowGUID, this.state.contact.tel1, this.state.contact.email, this.state.contact.idContact);

        chargementEDOCGenOTP
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };

    _onCacheDialogSignatureEffectuee = () => {
        this.setState({
            onAfficheDialogSignatureEffectuee: false
        });
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {
        return this._creationContent();
    }
}
